import humps from 'lodash-humps-ts';
import { omit } from 'lodash';
import { snakes } from '@utils/lodash';
import { authAxios } from '@components/Auth';
import { API_V1_BASE } from '@config';
import { NumericString, Numeric, WithParams } from '@utils/typescript';
import { InsuranceTypes } from '@models/InsuranceType';
import { CorporateHealthClaim } from '@models/CorporateHealthClaim';
import { PaymentInfo } from '@models/PaymentInfo';

export type CreateCorporateHealthClaimParams = WithParams<{
  corporate_health_order_id: Numeric;
  corporate_user_id: Numeric;
  insurance_type: InsuranceTypes;
  claim_type: string;
  supporting_documents: File[];
  total_claimed_amount: NumericString;
  accept_terms_and_conditions: boolean;
  mobileNumber: string;
  email?: string;
  paymentInfo: PaymentInfo;
}>;

export type GetCorporateHealthClaimParams = WithParams<{
  id: number;
}>;

export class CorporateHealthClaimApi {
  static create = async ({ paymentInfo, ...rest }: CreateCorporateHealthClaimParams) => {
    return await authAxios
      .postForm(`${API_V1_BASE}/user/corporate_health_claims`, {
        ...omit(snakes(rest), ['supporting_documents']),
        'payment_info[payment_method]': paymentInfo.paymentMethod,
        'payment_info[bank_name]': paymentInfo.bankName,
        'payment_info[beneficiary_name]': paymentInfo.beneficiaryName,
        'payment_info[bank_account]': paymentInfo.bankAccount,
        'supporting_documents[]': rest.supportingDocuments,
      })
      .then((response) => humps(response.data) as CorporateHealthClaim);
  };

  static get = async ({ id }: GetCorporateHealthClaimParams) => {
    return await authAxios
      .get(`${API_V1_BASE}/user/corporate_health_claims/${id}`)
      .then((response) => humps(response.data) as CorporateHealthClaim);
  };
}
